export default "__VITE_ASSET__64c1e7ec__"